import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-2",
  "use": "menu-2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"menu-2\"><defs><style>#menu-2 .cls-1{fill:none}</style></defs><title>资源 23</title><g id=\"menu-2_图层_2\" data-name=\"图层 2\"><g id=\"menu-2_图层_1-2\" data-name=\"图层 1\"><path id=\"menu-2_矩形_323\" data-name=\"矩形 323\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path id=\"menu-2_路径_1301\" data-name=\"路径 1301\" d=\"M20.84 1.5H3.19A1.69 1.69 0 0 0 1.5 3.19v17.65a1.69 1.69 0 0 0 1.69 1.66h17.65a1.71 1.71 0 0 0 1.66-1.66V3.19a1.7 1.7 0 0 0-1.66-1.69zm-9.07 16.31a2 2 0 0 0 2-2 2 2 0 0 0 0-.35L16 13.9h4.82v7H3.19v-9H8.5l2.63-1.9a1.9 1.9 0 0 0 1.06.33 2 2 0 0 0 2-2v-.1a2 2 0 1 0-3.94 0 2.16 2.16 0 0 0 0 .36L8 10.17H3.19v-7h17.65v9H15.5L12.9 14a2 2 0 1 0-1.13 3.77z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-2.svg
// module id = vgP0
// module chunks = 6